import store from "../store";
import axios from "./axios";

export default {
  async getStudentProfile(sid) {
    let studentProfile = null;
    studentProfile = await axios.postDataWithToken(
      "/auth/get-student-profile",
      { sid },
      localStorage.getItem("token")
    );
    return studentProfile;
  },
  async cardStatusTrue(sid) {
    if (sid) {
      const status = await axios.postDataWithToken(
        "/auth/get-card-status",
        { sid: this.student.sid },
        this.getAccessToken
      );

      if (status == "present") {
        return true;
      } else {
        return false;
      }
    }
  },
  async getStudentNotes(sid) {
    let notes = [];
    notes = await axios.postDataWithToken(
      "/auth/get-notes",
      { sid },
      localStorage.getItem("token")
    );
    return notes;
  },
  async savePayment(sid, date, amount, descriptionId) {
    let payments = [];
    payments = await axios.postDataWithToken(
      "/auth/save-payment",
      {
        sid,
        date,
        amount,
        descriptionId,
      },
      localStorage.getItem("token")
    );
    return payments;
  },
  async createStudentDiscount(sid, amount, reason, status) {
    const discounts = await axios.postDataWithToken(
      "/auth/create-student-discount",
      {
        sid,
        amount,
        reason,
        status,
      },
      localStorage.getItem("token")
    );
    return discounts;
  },
  async changeStatusOfDiscount(discountID, status) {
    const discounts = await axios.postDataWithToken(
      "/auth/change-status-of-discount",
      {
        discountID,
        status,
      },
      localStorage.getItem("token")
    );
    return discounts;
  },
  async getStudentDiscounts(sid) {
    const discounts = await axios.postDataWithToken(
      "/auth/get-student-discounts",
      {
        sid,
      },
      localStorage.getItem("token")
    );
    return discounts;
  },
  async getAllIncomesCategories() {
    const categories = await axios.getData(
      "/auth/get-all-income-categories",
      localStorage.getItem("token")
    );
    return categories;
  },

  async getStudents(force = false) {
    let students = [];

    store.commit("setLoader", true);
    if (!force && store.getters.getAllStudents.length > 0) {
      students = store.getters.getAllStudents;
    } else {
      students = await axios.getData(
        "/auth/get-all-students",
        localStorage.getItem("token")
      );
    }

    store.commit("setAllStudents", students);
    store.commit("setLoader", false);
    return students;
  },

  async getCardedStudents() {
    const cardedStudentsSIDs = await axios.getData(
      "/auth/get-carded-sids",
      localStorage.getItem("token")
    );
    return cardedStudentsSIDs;
  },

  async getAllPhotosSids() {
    const photosSids = [];
    const allPhotosSids = await axios.getData(
      "/auth/get-all-photos-sids",
      localStorage.getItem("token")
    );

    if (allPhotosSids.length > 0) {
      allPhotosSids.forEach((sidDotExtension) => {
        photosSids.push(sidDotExtension.split(".")[0]);
      });
    }
    return photosSids;
  },
  calculateOverdueBeforeCurrentMonth(data, starting_month) {
    const openingBalance = parseFloat(data.op.replace(/,/g, "")) || 0;
    const deposit = parseFloat(data.deposit.replace(/,/g, "")) || 0;
    const monthlyDue = parseFloat(data.monthly_due.replace(/,/g, "")) || 0;
    const totalPaid = parseFloat(data.totalPaid.replace(/,/g, "")) || 0;

    const statementMonth = new Date(data.statement_date).getMonth() + 1; // 1-indexed (Jan = 1)

    // Months between start and the month BEFORE current one
    const monthsElapsed = Math.max(0, statementMonth - starting_month);

    const expectedToHavePaid =
      openingBalance + deposit + monthlyDue * monthsElapsed;
    const overdue = expectedToHavePaid - totalPaid;

    return overdue > 0 ? overdue : 0;
  },
  async getStudentCardsWithPhotosTakenButNotPrinted(
    classs,
    allPhotosSids,
    cardedSids
  ) {
    const students = await axios.postDataWithToken(
      "/auth/get-students-with-photos-but-not-printed-by-class",
      { classs, allPhotosSids, cardedSids },
      localStorage.getItem("token")
    );

    return students;
  },

  async updateCardStatus(sid) {
    if (store.getters.getCurrentUser.email == "adubyte2@yahoo.com") {
      await axios.postDataWithToken(
        "/auth/update-card-status",
        { sid },
        localStorage.getItem("token")
      );
      return true;
    } else {
      return false;
    }
  },

  formatStudentsForAutocomplete(students) {
    const formattedStudents = [];
    if (students.length > 0) {
      students.forEach((student) => {
        formattedStudents.push({
          text:
            student.lname + " " + student.fname + " [ " + student.sid + " ]",
          value: student.sid,
        });
      });
      return formattedStudents;
    } else {
      return students;
    }
  },
  getStudentTel(telephoneNumber) {
    if (
      !telephoneNumber &&
      !telephoneNumber.includes("(H) <N/A> (E) <N/A>") &&
      !telephoneNumber.includes("(H) <N/A>\n(E) <N/A>")
    ) {
      let tel = "";
      tel = telephoneNumber.replace(/[^0-9]+/, "");
      tel = tel.replace(/\s/g, "");
      tel = tel.replace("(E)<N/A>", "");
      tel = tel.replace("(E)", "/");
      tel = tel.replace("<N/A>", "");
      tel = tel.trim();
      return tel;
    } else {
      return store.getters.getUserSchool.sch_tel;
    }
  },
};
